<ng-container *ngIf="showsTooltip">
    <div 
    class="tooltip"
    [style.top]="topPosition + 'px'"
    [style.left]="leftPosition + 'px'"
    >
      <div *ngIf="row1" class="tooltip__element">{{ row1Label }}: {{ row1 }}</div>
      <div *ngIf="row2" class="tooltip__element">{{ row2Label }}: {{ row2 }}</div>
      <div *ngIf="row3" class="tooltip__element">{{ row3Label }}: {{ row3 }}</div>
    </div>
</ng-container>